import { styles } from '@app/services/app-styles.service';

const chip = {
    root: {
        gap: styles().gapItemXs,
        paddingY: styles().padding1,
        background: styles().layerSecondary,
        color: styles().textColor,
    },
};

export default chip;
